import * as z from "zod";
import { carrierRateReviewSchema } from "./carrier-rate-change-set";

export const proposeCarrierRateChange = {
  name: "proposeCarrierRateChange" as const,
  input: z.object({
    carrier: z.string(),
    fileRoles: z.array(z.string()),
    effectiveFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    options: z.record(z.string(), z.string()),
    description: z.string().min(1),
  }),
  output: carrierRateReviewSchema.extend({
    changeSetId: z.string().nullable(),
  }),
  files: true,
};
